// extracted by mini-css-extract-plugin
export default {"card":"PersonCard_card__dmw0W","card__image":"PersonCard_card__image__jWeL2","card__name":"PersonCard_card__name__jIeKj","card__info":"PersonCard_card__info__Pp+-O"};